
import { useContext, useEffect, useState } from "react";
import Header from "../components/Header"
import LanguageSet from "../components/language/LanguageSet"
import LanguageContext from "../components/hooks/LanguageContext";
import { useNavigate } from "react-router-dom";
import LoadingSnip from "../components/LoadingSnip";
import { useAuth } from "../providers/AuthProvider";
import { getText } from "../utils/languageUtils";
import apiCall from "../api";

const API_COURSE_LIST = `course-list`;
const API_STUDENT_PROGRESS = `studentprogress`;

const MyProgress = () => {
    const { logout: authLogout, authDispatch } = useAuth();
    const { language, translations: translationData } = useContext(LanguageContext);
    const translations = translationData?.my_progress || {};
    const [loading, setLoading] = useState(false);
    const [progres, setProgress] = useState(0)
    const [progres2, setProgress2] = useState(0)
    const [progres3, setProgress3] = useState(0)
    const [progres4, setProgress4] = useState(0)
    const [courses, setCourses] = useState([])
    const navigate = useNavigate()

    const [showpoints, setShowPoints] = useState(true)
    const [flipLogo, setFlipLogo] = useState(false)

    // Define sections with routes (same as HomePage)
    const sections = [
        { goto: "/module/digital-safety" },
        { goto: "/module/digital-wellbeing" },
        { goto: "/module/digital-infoecosystem" },
        { goto: "/module/digital-agency" }
    ];

    // Helper function to navigate to a course section
    const navigateToCourse = (index) => {
        if (courses[index]) {
            navigate(sections[index].goto, {
                state: {
                    url: courses[index].url,
                    page_title: courses[index].title,
                }
            });
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const [courseListResponse, studentProgressResponse] = await Promise.all([
                    apiCall({ url: API_COURSE_LIST, method: "GET" }),
                    apiCall({ url: API_STUDENT_PROGRESS, method: 'POST' })
                ]);

                if (courseListResponse.data.message === "Invalid Access Token") {
                    authLogout();
                    navigate("/");
                    return;
                }

                if (courseListResponse?.status === 200) {
                    setCourses(courseListResponse.data?.course_summary || []);
                }

                if (studentProgressResponse.data.message === "Invalid Access Token") {
                    authLogout();
                    navigate("/");
                    return;
                }

                if (studentProgressResponse?.status === 200) {
                    const data = studentProgressResponse.data;
                    setProgress(Number(data.student_summary.course_progress[0].progress_percentage));
                    setProgress2(Number(data.student_summary.course_progress[1].progress_percentage));
                    setProgress3(Number(data.student_summary.course_progress[2].progress_percentage));
                    setProgress4(Number(data.student_summary.course_progress[3].progress_percentage));
                    const progress = data?.student_summary;
                    authDispatch({ type: "SET_PROGRESS", payload: { points: progress.points, progress } });
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [])


    useEffect(() => {

        // Flip logo for 2 seconds
        setShowPoints(true)
        setTimeout(() => {
            setShowPoints(false);
            setFlipLogo(true);

            setTimeout(() => {
                setFlipLogo(false)
            }, 3000)
            // Flip logo again for 2 seconds after showing the points
        }, 6000);
    }, [])


    const customValue = progres;
    const customStyle = {
        '--value': customValue,
    };

    const customValue2 = progres2;
    const customStyle2 = {
        '--value': customValue2,
    };

    const customValue3 = progres3;
    const customStyle3 = {
        '--value': customValue3,
    };

    const customValue4 = progres4;
    const customStyle4 = {
        '--value': customValue4,
    };

    return (
        <>
            <div id="body_bg">
                <Header page_title={getText(translationData?.home?.my_progress, language)} />
                <LanguageSet />
                {loading ?
                    (<LoadingSnip />)
                    : (
                        <div className="container-fluid px-0">
                            <div className="row justify-content-center">
                                <div className="col-xl-5 col-md-12">
                                    <section className="my-3">
                                        <div className="container-fluid ">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="sectionsBox">
                                                        <p className="mb-0 text-center">{getText(translationData?.home?.my_progress, language)}</p>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="row mt-4 justify-content-center">
                                                <div className="col-xl-12 text-center position-relative">
                                                    <div className="progressbarMy mb-5 d-flex gap-4 align-items-center ">
                                                        <div className="section1">
                                                            <p className="mb-0  p_column">
                                                                {getText(translations?.section_1, language)}
                                                            </p>
                                                        </div>
                                                        {/*section1 start */}
                                                        {
                                                            progres === 0 ?
                                                                <div className="completeImg stepper-item">
                                                                    <img src={require("../assets/images/lock.png")} alt="lock" />
                                                                </div>
                                                                : (progres > 0 && progres < 80) ?

                                                                    <div className="progress_my" role="progressbar" onClick={() => navigateToCourse(0)}
                                                                        aria-valuenow={progres > 0 ?
                                                                            progres + "%" :
                                                                            <img src={require("../assets/images/lock.png")} alt="lock" />}
                                                                        aria-valuemin="0" aria-valuemax="100" style={{ ...customStyle, cursor: "pointer" }}>
                                                                    </div>
                                                                    :
                                                                    (progres >= 80) ?
                                                                        (
                                                                            showpoints ?
                                                                                <div className="progress_my" role="progressbar"
                                                                                    aria-valuenow={progres > 0 ?
                                                                                        progres + "%" :
                                                                                        <img src={require("../assets/images/lock.png")} alt="lock" />}
                                                                                    aria-valuemin="0" aria-valuemax="100" style={customStyle}
                                                                                >
                                                                                </div>
                                                                                : <img style={{ width: 120 }} src={require("../assets/images/yellow.png")} className={flipLogo ? "flip-logo" : ""} alt="yellow.png" />
                                                                        )

                                                                        :
                                                                        <div className="completeImg stepper-item">
                                                                            <img src={require("../assets/images/lock.png")} alt="lock" />
                                                                        </div>
                                                        }

                                                    </div>
                                                    <div className="progressbarMy mb-5 d-flex gap-4 align-items-center">
                                                        <div className="section1">
                                                            <p className="mb-0  p_column">
                                                                {getText(translations?.section_2, language)}
                                                            </p>
                                                        </div>
                                                        {/*section -2  start */}
                                                        {(progres >= 80 && progres2 === 0) ?
                                                            <div onClick={() => navigateToCourse(1)}>
                                                                <img style={{ width: 120, cursor: "pointer" }} src={require("../assets/images/unlock.png")} alt="unlock.png" />
                                                            </div>
                                                            : (progres >= 80 && progres2 > 0 && progres2 < 80) ?
                                                                <div className="progress_my" role="progressbar" onClick={() => navigateToCourse(1)}
                                                                    aria-valuenow={progres2 > 0 ?
                                                                        progres2 + "%" :
                                                                        <img src={require("../assets/images/lock.png")} alt="unlock.png" />}
                                                                    aria-valuemin="0" aria-valuemax="100" style={{ ...customStyle2, cursor: "pointer" }}>
                                                                </div>
                                                                : (progres >= 80 && progres2 >= 80) ?
                                                                    (
                                                                        showpoints ?
                                                                            <div className="progress_my" role="progressbar"
                                                                                aria-valuenow={progres2 > 0 ?
                                                                                    progres2 + "%" :
                                                                                    <img src={require("../assets/images/lock.png")} alt="unlock.png" />}
                                                                                aria-valuemin="0" aria-valuemax="100" style={customStyle2}>
                                                                            </div>
                                                                            :

                                                                            <img style={{ width: 120 }} src={require("../assets/images/yellow.png")} className={flipLogo ? "flip-logo" : ""} alt="yellow.png" />

                                                                    )

                                                                    :
                                                                    <div className="completeImg stepper-item">
                                                                        <img src={require("../assets/images/lock.png")} alt="lock.png" />
                                                                    </div>
                                                        }


                                                    </div>
                                                    <div className="progressbarMy mb-5 d-flex gap-4 align-items-center">
                                                        <div className="section1">
                                                            <p className="mb-0  p_column">
                                                                {getText(translations?.section_3, language)}
                                                            </p>
                                                        </div>
                                                        {/*section -3  start */}
                                                        {(progres2 >= 80 && progres3 === 0) ?
                                                            <div onClick={() => navigateToCourse(2)}>
                                                                <img style={{ width: 120, cursor: "pointer" }} src={require("../assets/images/unlock.png")} alt="unlock.png" />
                                                            </div>


                                                            : (progres2 >= 80 && progres3 > 0 && progres3 < 80) ?
                                                                <div className="progress_my" role="progressbar"
                                                                    onClick={() => navigateToCourse(2)}
                                                                    aria-valuenow={progres3 > 0 ?
                                                                        progres3 + "%" :
                                                                        <img src={require("../assets/images/lock.png")} alt="lock.png" />}
                                                                    aria-valuemin="0" aria-valuemax="100" style={{ ...customStyle3, cursor: "pointer" }}
                                                                >
                                                                </div>
                                                                : (progres2 >= 80 && progres3 >= 80) ?
                                                                    (
                                                                        showpoints ?
                                                                            <div className="progress_my" role="progressbar"
                                                                                aria-valuenow={progres3 > 0 ?
                                                                                    progres3 + "%" :
                                                                                    <img src={require("../assets/images/lock.png")} alt="lock.png" />}
                                                                                aria-valuemin="0" aria-valuemax="100" style={customStyle3}>
                                                                            </div>
                                                                            :

                                                                            <img style={{ width: 120 }} src={require("../assets/images/yellow.png")} className={flipLogo ? "flip-logo" : ""} alt="yellow.png" />

                                                                    )
                                                                    :
                                                                    <div className="completeImg stepper-item">
                                                                        <img src={require("../assets/images/lock.png")} alt="lock.png" />
                                                                    </div>
                                                        }


                                                    </div>
                                                    <div className="progressbarMy mb-5 d-flex gap-4 align-items-center">
                                                        <div className="section1">
                                                            <p className="mb-0  p_column">
                                                                {getText(translations?.section_4, language)}
                                                            </p>
                                                        </div>
                                                        {/*section - 4  start */}
                                                        {(progres3 >= 80 && progres4 === 0) ?
                                                            <div onClick={() => navigateToCourse(3)}>
                                                                <img style={{ width: 120, cursor: "pointer" }} src={require("../assets/images/unlock.png")} alt="unlock.png" />
                                                            </div>
                                                            : (progres3 >= 80 && progres4 > 0 && progres4 < 80) ?
                                                                <div className="progress_my" role="progressbar"
                                                                    onClick={() => navigateToCourse(3)}
                                                                    aria-valuenow={progres4 > 0 ?
                                                                        progres4 + "%" :
                                                                        <img src={require("../assets/images/lock.png")} alt="lock.png" />}
                                                                    aria-valuemin="0" aria-valuemax="100" style={{ ...customStyle4, cursor: "pointer" }}>
                                                                </div>
                                                                : (progres3 >= 80 && progres4 >= 80) ?
                                                                    (
                                                                        showpoints ?
                                                                            <div className="progress_my" role="progressbar"
                                                                                aria-valuenow={progres4 > 0 ?
                                                                                    progres4 + "%" :
                                                                                    <img src={require("../assets/images/lock.png")} alt="lock.png" />}
                                                                                aria-valuemin="0" aria-valuemax="100" style={customStyle}>
                                                                            </div>
                                                                            :

                                                                            <img style={{ width: 120 }} src={require("../assets/images/yellow.png")} className={flipLogo ? "flip-logo" : ""} alt="yellow.png" />

                                                                    )
                                                                    :
                                                                    <div className="completeImg stepper-item">
                                                                        <img src={require("../assets/images/lock.png")} alt="lock.png" />
                                                                    </div>
                                                        }


                                                    </div>
                                                </div>

                                            </div>




                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    )}

            </div>
        </>
    )
}

export default MyProgress